import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_OLD } from '../data/finanza';
const recap = ['6 volumi', '5 bonus', '240 pagine', 'Primaria e Secondaria'];
const reassurances = ['Accesso immediato', 'PDF da stampare', 'Garanzia di 7 giorni'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-111" data-mp="15bsodlj70gm7">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-[#FF8A7A] sm:left-8 lg:left-12" data-id="element-112" data-mp="1jbk6nygqsj60" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-113" data-mp="1ec7kzh1lxi50">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-[#1E2B58] sm:text-6xl" data-id="element-114" data-mp="1t1n1833ii56g">
          Entra in aula con l'educazione finanziaria <em className="text-[#1F9D6B]" data-id="element-115" data-mp="223d17xbgmcfu">già pronta.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-[#1E2B58]/75" data-id="element-116" data-mp="221jsmchadi57">
          Invece di cercare schede, adattare livelli e passare le serate a inventare problemi, hai un
          sistema di educazione finanziaria organizzato per tutto l'anno scolastico. Più tempo per
          quello che conta davvero:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-[#1E2B58] sm:text-3xl" data-id="element-117" data-mp="x420wf5grvg4">
          I tuoi alunni. Le tue lezioni. La tua vita fuori dalla scuola.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-[#1E2B58]/70" data-id="element-118" data-mp="164gm7eifhajm">
          {recap.map(item => <li key={item} data-id="element-119" data-mp="1b2rydvw73x50">{item}</li>)}
        </ul>

        <p className="mt-8 text-sm text-[#1E2B58]/60" data-id="element-120" data-mp="1b170bwao9w2e">invece di <s data-id="element-121" data-mp="1fvb98l3i0e64">{PRICE_OLD}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-[#1E2B58] sm:text-7xl" data-id="element-122" data-mp="1fv1qniks99ag">{PRICE}</p>
        <p className="mt-3 text-sm text-[#1E2B58]/70" data-id="element-123" data-mp="1kv7e0mk0s9mq">Pagamento unico – nessun abbonamento.</p>

        <div className="mt-8 flex justify-center" data-id="element-124" data-mp="1pqd0pnl8xsbv">
          <CtaButton className="w-full sm:w-auto" data-id="element-125" data-mp="1tv2un6wcgwu5" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-[#1E2B58]/70" data-id="element-126" data-mp="3quoycxuuozqg">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-127" data-mp="3lwndq8hs0scv">
              <CheckIcon className="h-4 w-4 text-[#1F9D6B]" aria-hidden="true" data-id="element-128" data-mp="3hl6d9nvmido" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}